// extracted by mini-css-extract-plugin
export default {"wrap":"EditPhoto_wrap__NzL1X","carousel":"EditPhoto_carousel__8HYF0","img_wrap":"EditPhoto_img_wrap__tTfzQ","panel_wrap":"EditPhoto_panel_wrap__XK4WD"};